import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";
import Icon from "../../Icon";

const ConfirmationDialog = () => {
  const [openModals, setOpenModals] = useState({});

  const toggleModal = (id) => {
    setOpenModals(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* SECTION 1: CONFIRMATION TYPES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Confirmation Types</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* Variation 1: Basic Confirm */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Confirmation</label>
            <button onClick={() => toggleModal('modal1')} className="px-3 py-2 bg-amber-600 hover:bg-amber-500 text-sm font-semibold text-white rounded w-full">Open Dialog</button>
            {openModals['modal1'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-slate-700 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-slate-100">Save Changes?</h3>
                  <p className="text-sm text-slate-400 mt-2">You have unsaved changes in your project.</p>
                  <div className="flex gap-2 mt-6">
                    <button onClick={() => toggleModal('modal1')} className="flex-1 px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Cancel</button>
                    <button onClick={() => toggleModal('modal1')} className="flex-1 px-3 py-2 bg-amber-600 hover:bg-amber-500 text-sm font-semibold text-white rounded">Save</button>
                  </div>
                </div>
              </div>
            )}
            <CopyCode number_code={1} code={`const [open, setOpen] = useState(false);

{open && (
  <div className="fixed inset-0 bg-black/50 
    flex items-center justify-center z-50">
    <div className="bg-slate-950 rounded-lg p-6 max-w-sm">
      <h3 className="text-lg font-bold">Save Changes?</h3>
      <p className="text-sm text-slate-400 mt-2">
        You have unsaved changes.
      </p>
      <div className="flex gap-2 mt-6">
        <button onClick={() => setOpen(false)}>
          Cancel
        </button>
        <button className="bg-amber-600">Save</button>
      </div>
    </div>
  </div>
)}`} />
          </div>

          {/* Variation 2: Delete Confirmation */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Delete Confirmation</label>
            <button onClick={() => toggleModal('modal2')} className="px-3 py-2 bg-red-600 hover:bg-red-500 text-sm font-semibold text-white rounded w-full">Delete Item</button>
            {openModals['modal2'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-red-700/50 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-red-400">Delete Permanently?</h3>
                  <p className="text-sm text-slate-400 mt-2">This action cannot be undone. The file "document.pdf" will be lost.</p>
                  <div className="flex gap-2 mt-6">
                    <button onClick={() => toggleModal('modal2')} className="flex-1 px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Cancel</button>
                    <button onClick={() => toggleModal('modal2')} className="flex-1 px-3 py-2 bg-red-600 hover:bg-red-500 text-sm font-semibold text-white rounded">Delete</button>
                  </div>
                </div>
              </div>
            )}
            <CopyCode number_code={2} code={`{open && (
  <div className="fixed inset-0 bg-black/50 
    flex items-center justify-center z-50">
    <div className="bg-slate-950 
      border border-red-700/50 rounded-lg p-6">
      <h3 className="text-lg text-red-400">
        Delete Permanently?
      </h3>
      <p className="text-slate-400 mt-2">
        This action cannot be undone.
      </p>
      <div className="flex gap-2 mt-6">
        <button>Cancel</button>
        <button className="bg-red-600">Delete</button>
      </div>
    </div>
  </div>
)}`} />
          </div>

          {/* Variation 3: Danger Action */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Danger Confirmation</label>
            <button onClick={() => toggleModal('modal3')} className="px-3 py-2 bg-orange-600 hover:bg-orange-500 text-sm font-semibold text-white rounded w-full">Reset Password</button>
            {openModals['modal3'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-orange-700/50 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-orange-400 inline-flex items-center gap-2"><Icon name="warning" className="w-5 h-5" /> Reset Password</h3>
                  <p className="text-sm text-slate-400 mt-2">This will log you out of all devices and send a reset email.</p>
                  <div className="flex gap-2 mt-6">
                    <button onClick={() => toggleModal('modal3')} className="flex-1 px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Cancel</button>
                    <button onClick={() => toggleModal('modal3')} className="flex-1 px-3 py-2 bg-orange-600 hover:bg-orange-500 text-sm font-semibold text-white rounded">Continue</button>
                  </div>
                </div>
              </div>
            )}
            <CopyCode number_code={3} code={`<div className="bg-slate-950 
  border border-orange-700/50 rounded-lg p-6">
  <h3 className="text-lg text-orange-400">
    Reset Password
  </h3>
  <p className="text-slate-400 mt-2">
    This will log you out of all devices 
    and send a reset email.
  </p>
  <div className="flex gap-2 mt-6">
    <button>Cancel</button>
    <button className="bg-orange-600">Continue</button>
  </div>
</div>`} />
          </div>

          {/* Variation 4: Info Confirmation */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Info Confirmation</label>
            <button onClick={() => toggleModal('modal4')} className="px-3 py-2 bg-blue-600 hover:bg-blue-500 text-sm font-semibold text-white rounded w-full">Update Settings</button>
            {openModals['modal4'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-blue-700/50 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-blue-300">Enable 2FA?</h3>
                  <p className="text-sm text-slate-400 mt-2 inline-flex items-center gap-2"><Icon name="info" className="w-4 h-4" /> Two-factor authentication adds an extra layer of security to your account.</p>
                  <div className="flex gap-2 mt-6">
                    <button onClick={() => toggleModal('modal4')} className="flex-1 px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Later</button>
                    <button onClick={() => toggleModal('modal4')} className="flex-1 px-3 py-2 bg-blue-600 hover:bg-blue-500 text-sm font-semibold text-white rounded">Enable</button>
                  </div>
                </div>
              </div>
            )}
            <CopyCode number_code={4} code={`<div className="bg-slate-950 
  border border-blue-700/50 rounded-lg p-6">
  <h3 className="text-lg text-blue-300">
    Enable 2FA?
  </h3>
  <p className="text-slate-400 mt-2">
    This adds extra security to your account.
  </p>
  <div className="flex gap-2 mt-6">
    <button>Later</button>
    <button className="bg-blue-600">Enable</button>
  </div>
</div>`} />
          </div>

        </div>
      </div>

      {/* SECTION 2: ADVANCED DIALOGS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Dialogs</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* Variation 5: Custom Actions */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Custom Actions</label>
            <button onClick={() => toggleModal('modal5')} className="px-3 py-2 bg-amber-600 hover:bg-amber-500 text-sm font-semibold text-white rounded w-full">Continue Editing</button>
            {openModals['modal5'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-amber-700/50 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-amber-300">Session Expired</h3>
                  <p className="text-sm text-slate-400 mt-2">Your session has expired. Continue editing or start a new session?</p>
                  <div className="flex flex-col gap-2 mt-6">
                    <button className="px-3 py-2 bg-amber-600 hover:bg-amber-500 text-sm font-semibold text-white rounded">Continue Editing</button>
                    <button onClick={() => toggleModal('modal5')} className="px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Start Fresh</button>
                  </div>
                </div>
              </div>
            )}
            <CopyCode number_code={5} code={`<div className="flex flex-col gap-2 mt-6">
  <button className="px-3 py-2 
    bg-amber-600 text-white rounded">
    Continue Editing
  </button>
  <button className="px-3 py-2 
    bg-slate-700 text-slate-100 rounded">
    Start Fresh
  </button>
</div>`} />
          </div>

          {/* Variation 6: With Input Field */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Input Field</label>
            <button onClick={() => toggleModal('modal6')} className="px-3 py-2 bg-amber-600 hover:bg-amber-500 text-sm font-semibold text-white rounded w-full">Rename Project</button>
            {openModals['modal6'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-amber-700/50 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-slate-100">Rename Project</h3>
                  <input type="text" placeholder="Enter new name" className="w-full mt-4 px-3 py-2 bg-slate-800 border border-slate-700 rounded text-slate-100 text-sm placeholder-slate-400" />
                  <div className="flex gap-2 mt-6">
                    <button onClick={() => toggleModal('modal6')} className="flex-1 px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Cancel</button>
                    <button onClick={() => toggleModal('modal6')} className="flex-1 px-3 py-2 bg-amber-600 hover:bg-amber-500 text-sm font-semibold text-white rounded">Rename</button>
                  </div>
                </div>
              </div>
            )}
            <CopyCode number_code={6} code={`<div className="bg-slate-950 rounded-lg p-6">
  <h3 className="text-lg font-bold">Rename Project</h3>
  <input type="text" placeholder="Enter new name" 
    className="w-full mt-4 px-3 py-2 
    bg-slate-800 border border-slate-700 rounded" />
  <div className="flex gap-2 mt-6">
    <button>Cancel</button>
    <button className="bg-amber-600">Rename</button>
  </div>
</div>`} />
          </div>

          {/* Variation 7: Multiple Options */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multiple Options</label>
            <button onClick={() => toggleModal('modal7')} className="px-3 py-2 bg-emerald-600 hover:bg-emerald-500 text-sm font-semibold text-white rounded w-full">Share File</button>
            {openModals['modal7'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-emerald-700/50 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-slate-100">Share File</h3>
                  <p className="text-sm text-slate-400 mt-2">Choose sharing method:</p>
                  <div className="space-y-2 mt-4">
                    <button className="w-full p-3 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded text-left text-sm text-slate-200 inline-flex items-center gap-2"><Icon name="mail" className="w-4 h-4" /> Email</button>
                    <button className="w-full p-3 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded text-left text-sm text-slate-200 inline-flex items-center gap-2"><Icon name="link" className="w-4 h-4" /> Link</button>
                    <button className="w-full p-3 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded text-left text-sm text-slate-200 inline-flex items-center gap-2"><Icon name="users" className="w-4 h-4" /> Team</button>
                  </div>
                  <button onClick={() => toggleModal('modal7')} className="w-full mt-4 px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Close</button>
                </div>
              </div>
            )}
            <CopyCode number_code={7} code={`<div className="space-y-2 mt-4">
  <button className="w-full p-3 bg-slate-800 
    border border-slate-700 rounded text-left">
    Email
  </button>
  <button className="w-full p-3 bg-slate-800 
    border border-slate-700 rounded text-left">
    Link
  </button>
  <button className="w-full p-3 bg-slate-800 
    border border-slate-700 rounded text-left">
    Team
  </button>
</div>`} />
          </div>

          {/* Variation 8: Progress Dialog */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Progress Dialog</label>
            <button onClick={() => toggleModal('modal8')} className="px-3 py-2 bg-indigo-600 hover:bg-indigo-500 text-sm font-semibold text-white rounded w-full">Upload File</button>
            {openModals['modal8'] && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 mt-96">
                <div className="bg-slate-950 border border-indigo-700/50 rounded-lg p-6 max-w-sm w-full">
                  <h3 className="text-lg font-bold text-slate-100">Upload Progress</h3>
                  <p className="text-sm text-slate-400 mt-2">Uploading: document.pdf</p>
                  <div className="w-full h-2 bg-slate-700 rounded-full mt-4 overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-indigo-500 to-indigo-600 w-7/12"></div>
                  </div>
                  <p className="text-xs text-slate-400 mt-2">58% complete</p>
                  <button onClick={() => toggleModal('modal8')} className="w-full mt-6 px-3 py-2 bg-slate-700 hover:bg-slate-600 text-sm font-semibold text-slate-100 rounded">Cancel</button>
                </div>
              </div>
            )}
            <CopyCode number_code={8} code={`<div className="w-full h-2 bg-slate-700 
  rounded-full mt-4 overflow-hidden">
  <div className="h-full bg-gradient-to-r 
    from-indigo-500 to-indigo-600 w-7/12">
  </div>
</div>
<p className="text-xs text-slate-400 mt-2">
  58% complete
</p>`} />
          </div>

        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;


